import { useEffect, useRef } from 'react';

export function useWakeLock(enabled: boolean): void {
    const wakeLockRef = useRef<WakeLockSentinel | null>(null);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;

        async function requestWakeLock(): Promise<void> {
            const isSupported = typeof window !== 'undefined' && 'wakeLock' in navigator;

            if (!isSupported) {
                return;
            }

            try {
                const wakeLock = await navigator.wakeLock.request('screen');

                if (cancelled) {
                    await wakeLock.release();
                    return;
                }

                wakeLockRef.current = wakeLock;
            } catch {
                // catching as a guard for possible edge cases
            }
        }

        void requestWakeLock();

        return () => {
            cancelled = true;
            wakeLockRef.current?.release().catch(() => {});
            wakeLockRef.current = null;
        };
    }, [enabled]);
}
